<template>
  <div id="PlayVideo">
    <Modal
        :title="editTitle"
        v-model="showDrawer"
        width="50%"
        footer-hide
        @on-cancel="onClosePlay"
        class-name="vertical-center-modal">
      <iframe style="width:100%;height:600px;margin-top: 20px;" ref="video" frameborder=0 allowfullscreen></iframe>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "PlayVideo",
  data() {
    return {
      editTitle: '',
      showDrawer: false,
      videoInfo: {
        url: ''
      }
    }
  },
  methods: {
    playVideo(video) {
      this.videoInfo = video
      this.$refs.video.src = this.videoInfo.url
      this.showDrawer = true
    },
    onClosePlay() {
      this.$refs.video.src = ""
    }
  }
}
</script>

<style scoped>
.vertical-center-modal{
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
